module.exports = __webpack_public_path__ + "named-2c7d581f3ce6842f807f30b0e043dbf6-apple-touch-icon-152x152.png";